// extracted by mini-css-extract-plugin
export var cardSelected = "_if-2";
export var image = "_if-1";
export var table = "_if-0";